__turbopack_context__.v({
  "wrapper": "ArticleModuleSocialMediaSharer-module-scss-module__cHbNsq__wrapper",
});
